import { useMemo } from 'react';

function useConfig() {
  return useMemo(function () {
    return config;
  }, []);
}

export { useConfig };
//# sourceMappingURL=useConfig.js.map
